import React, {createContext, useEffect, useLayoutEffect, useState} from "react";
import {axiosPublic} from "../service/axios";

export const AccountContext = createContext(null);

const AccountProvider = ({children}) => {
	const [loading, setLoading] = useState(true);
	// const [cookie, setCookie] = useState(cookies.get('email'));
	const [accessToken, setAccessToken] = useState();
	const [cookie, setCookie] = useState();
	const [account, setAccount] = useState({});
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [redirectTo, setRedirectTo] = useState("");
	const [isAdmin, setIsAdmin] = useState(false);

	// useEffect(() => {
	//     setCookie(cookies.get('email'));
	//     console.log("(AccountProvider) Cookie in useEffect: ", cookie);
	// }, []);q

	useLayoutEffect(() => {
		const initAuth = async () => {
			if (accessToken === undefined) {
				console.log("(AccountProvider.jsx) Access Token is not set | Website Reloaded | Page Refreshed");
				try {
					const response = await axiosPublic.get('/auth/refresh-access-token', {
						withCredentials: true
					});
					console.log("(AccountProvider.jsx) Initial Fetch of Access Token: ", response);

					if (response.data.success) {
						setAccessToken(response.data.data.accessToken);
						setAccount(response.data.data.user);

						if (response.data.data.accessToken && response.data.data.user) {
							console.log("(AccountProvider) Account: ", response.data.data.user);
							setIsAuthenticated(true);
							if (response.data.data.user.primaryRole === "SUPER-USER") {
								setIsAdmin(true);
							}
						}
					}
				} catch (error) {
					console.log("(AccountProvider.jsx) Error fetching Access Token: ", error);
				} finally {
					setLoading(false);
				}
			}
		}

		initAuth();
		// const fetchAccount = async () => {
		//     setLoading(true);
		//     if (cookie) {
		//         const data = await getAccount({email: cookie});
		//         console.log("(AccountProvider) Account Data: ", data);
		//         if (data) {
		//             setAccount(data);
		//             setIsAuthenticated(true);
		//             if (data.primaryRole === "SUPER-USER") {
		//                 setIsAdmin(true);
		//             }
		//         }
		//     }
		//     setLoading(false);
		// };
		// fetchAccount();
	}, [accessToken]);

	useEffect(() => {
		console.log("(AccountProvider) Updated Access Token: ", accessToken);
		console.log("(AccountProvider) Updated Account Details: ", account);
		if (account && accessToken) {
			console.log("(AccountProvider) Account: ", account);
			setIsAuthenticated(true);
			if (account.primaryRole === "SUPER-USER") {
				setIsAdmin(true);
			}
		} else {
			setIsAuthenticated(false);
			setIsAdmin(false);
		}
	}, [account, accessToken]);

	return (
		<AccountContext.Provider value={{
			account,
			setAccount,
			cookie,
			setCookie,
			accessToken,
			setAccessToken,
			loading,
			isAuthenticated,
			setIsAuthenticated,
			redirectTo,
			setRedirectTo,
			isAdmin,
			setIsAdmin
		}}>
			{children}
		</AccountContext.Provider>
	)
}
export default AccountProvider;
